module.exports = __webpack_public_path__ + "media/images/crypto-currencies/qtum-62afdf9c999d39c8e379fb5a0b580227.svg";